if (!customElements.get('business-signup')) {
  customElements.define('business-signup', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.form = this.querySelector('form');
      this.button = this.form.querySelector('[type="submit"]');
      this.status = this.querySelector('[role="status"]');
      this.buttonLabel = this.button.textContent;
      this.form.addEventListener('submit', (event) => this.submit(event));
      this.form.addEventListener('input', (event) => {
        if (event.target.setCustomValidity) event.target.setCustomValidity('');
      });
      this.button.disabled = false;
    }

    showStatus(message, focus = false) {
      this.status.textContent = message;
      this.status.hidden = false;
      if (focus) this.status.focus();
    }

    async submit(event) {
      event.preventDefault();
      if (this.submitting) return;

      for (const field of this.form.querySelectorAll('input[required]')) {
        field.setCustomValidity(field.value.trim() ? '' : this.dataset.required);
      }
      if (!this.form.reportValidity()) return;

      const customer = Object.fromEntries(new FormData(this.form).entries());
      for (const key of Object.keys(customer)) customer[key] = customer[key].trim();
      // The endpoint expects five digits, while the form also accepts "123 45".
      for (const key of ['customer[note][Bolag_Postnummer]', 'customer[note][Leverans_Postnummer]']) {
        customer[key] = customer[key].replace(/\s/g, '');
      }

      this.submitting = true;
      this.button.disabled = true;
      this.button.textContent = this.dataset.submitting;
      this.form.setAttribute('aria-busy', 'true');
      this.showStatus(this.dataset.submitting);

      try {
        if (!window.api?.fetch) throw new Error('Signup client unavailable');
        const response = await window.api.fetch('/customer/signup', {
          method: 'POST',
          body: JSON.stringify({ customer, shopID: Number(this.dataset.shopId) }),
        });
        // Match the success contract of the original signup endpoint.
        if (response.status !== 200) throw new Error('Signup failed');
        this.form.reset();
        this.showStatus(this.dataset.success, true);
      } catch {
        this.showStatus(this.dataset.error, true);
      } finally {
        this.submitting = false;
        this.button.disabled = false;
        this.button.textContent = this.buttonLabel;
        this.form.removeAttribute('aria-busy');
      }
    }
  });
}
